module.exports = {
  matchSKU: function (SKU, params = {maxDigitsNumber: 3}) {
    SKU = SKU.replace(/\n+$/, "") /* replace all last new line character*/
    if (params.maxDigitsNumber == 3) {
      return SKU.match(/^(\d+\.\d+\.\d+)(-[a-z0-9]*)?$/i)
    } else if (params.maxDigitsNumber == 4) {
      return SKU.match(/^(\d+\.\d+\.\d+)(\.(\d+))?(-[a-z0-9]*)?$/i)
    }
  }
}
